import { render, staticRenderFns } from "./OrderFail.vue?vue&type=template&id=587bfc8e&scoped=true"
import script from "./OrderFail.vue?vue&type=script&lang=js"
export * from "./OrderFail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587bfc8e",
  null
  
)

export default component.exports